import React from "preact/compat";
import { ModalBodyProps } from "./modalBody.type";

export const ModalBody: React.FunctionComponent<ModalBodyProps> = ({
    className,
    children,
    onClose
}) => {
    return (
        <div className={`modal-body ${className}`}>
            {children}
            <button type="button" className="btn btn-link position-absolute end-0 pt-0 pe-0 lh-1" data-bs-dismiss="modal" onClick={onClose}>
                <img src="data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'><path d='M14.9999 1L0.919922 15.08M0.919922 1L14.9999 15.08' stroke='%23727272' stroke-width='1.2'/></svg>" alt="close" width={12} height={12} />
            </button>
        </div>
    )
}